import React, {useEffect, useState} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Routes } from '../../constants/RouterConstants';
import { getJobs } from '../../services/API/MarketplaceService';

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

function NotificationDeeplinkManagement() {
    const history = useHistory();
    const query = useQuery();
    const navigateTo = query.get('navigateTo');
    const company = query.get('company');
    const [appliedJobs, setAppliedJobs] = useState([]);

    const navigateToAppStatusPage = (allAppliedJobs) => {
        for (let i=0;i<allAppliedJobs.length;i++) {
            if (allAppliedJobs[i].companyName.toLowerCase() === company.toLowerCase()) {
                const siId = allAppliedJobs[i].scheduledInterviewId;
                if (navigateTo === 'applicationStatus') {
                    history.replace(`${Routes.APPLICATION_STATUS}?applicationId=${siId}`);
                } else if (navigateTo==='documentsUpload') {
                    window.location.href = `https://jsonplaceholder.typicode.com/photos/1?siId=${siId}`;
                } else {
                    history.replace(`${Routes.JOB_LISTINGS}?city=${localStorage.getItem('preferredLocation')}`);
                }
            }
        }
    };

    useEffect(() => {
        const selectedCity = localStorage.getItem('preferredLocation');
        const userId = localStorage.getItem('userId');
        getJobs(`"${selectedCity}"`, '', userId)
        .then(response => {
          setAppliedJobs([...response.data.viewData.allJobDemands.appliedJobDemands] || []);

          if (navigateTo && company) navigateToAppStatusPage([...response.data.viewData.allJobDemands.appliedJobDemands]);
        })
        .catch(error => {
          console.log(error);
        });
    }, [])
    
  return (
    <div>{navigateTo}{company}</div>
  )
}

export default NotificationDeeplinkManagement
